import { useEffect, useState } from "react";

export function useCinematic() {
  const [cinematic, setCinematic] = useState(true);

  useEffect(() => {
    // La cinemática 3D también corre en móvil; solo se desactiva si el
    // usuario pidió reducir movimiento (accesibilidad).
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setCinematic(!reduced.matches);
    update();
    reduced.addEventListener("change", update);
    return () => {
      reduced.removeEventListener("change", update);
    };
  }, []);

  return cinematic;
}

export function useFinePointer() {
  const [fine, setFine] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(pointer: fine)");
    const update = () => setFine(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);
  return fine;
}
